import styled from 'styled-components'

export const EmptyCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 12px;
  padding: 48px 32px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  border: 1px solid #e5e7eb;
  margin-top: 8px;
`

export const EmptyIconWrapper = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #a0d6ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
`

export const EmptyIcon = styled.span`
  font-size: 1.6rem;
  color: #00599c;
`

export const EmptyTitle = styled.p`
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #1f2937;
`

export const EmptyHint = styled.p`
  margin: 0;
  font-size: 0.875rem;
  color: #6b7280;
  line-height: 1.55;
  max-width: 320px;
`

export const StartupsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const PaginationFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1rem;
  gap: 0.75rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`

export const PaginationControls = styled.div`
  display: flex;
  align-items: center;
`

export const PaginationNavButton = styled.button`
  border: none;
  background: none;
  color: #0066b3;
  padding: 0;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:not(:disabled) {
    cursor: pointer;
    opacity: 1;
  }
`

export const PaginationPrevButton = styled(PaginationNavButton)`
  margin-right: 0.5rem;
`

export const PaginationNextButton = styled(PaginationNavButton)`
  margin-left: 0.5rem;
`

export const PaginationChevronIcon = styled.i`
  font-size: 1.2rem;
`

export const ItemsPerPageLabel = styled.div`
  color: #0066b3;
`
